export default "__VITE_ASSET__71e0d496__"